import React, { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { AllStatusProject, ProjectItem } from '@app/interfaces/analytics';

import {
  useGetSingleChatProjectQuery,
  useGetStatusOfChatAnalyticProjectQuery,
} from '@app/store/api/chat-api/chat-analytic.api';

import { NotFoundedPage } from '@app/pages';
import { Loading } from '@app/components/ui';

import { ChatAnalyticPageHeader } from './blocks/chat-analytic-page-header';

export type AnalyticPageOutlet = {
  project?: ProjectItem | null;
  loading?: boolean;
  status:
    | {
        project_status: AllStatusProject;
      }
    | undefined;
  disabled?: boolean;
  currentTemplate: 'chat' | 'voice';
};

const AnalyticDetailsLayout = () => {
  const { id } = useParams();
  const [pollingSkip, changePollingSkip] = useState(false);
  const [projectStatus, changeProjectStatus] = useState<AllStatusProject>();
  //api
  const { data: status } = useGetStatusOfChatAnalyticProjectQuery(
    { id: id },
    { pollingInterval: pollingSkip ? undefined : 2000 },
  );
  const {
    data: analyticProject,
    isError,
    isLoading,
  } = useGetSingleChatProjectQuery({ id: id || '' }, { pollingInterval: 30000 });
  //api

  const analyticPageOutlet: AnalyticPageOutlet = {
    project: { ...analyticProject, disabled: true } as ProjectItem,
    currentTemplate: 'chat',
    status,
  };

  if (isError) return <NotFoundedPage />;
  if (isLoading) return <Loading />;
  return (
    <div className="pb-[35px]">
      <ChatAnalyticPageHeader
        changePollingSkip={changePollingSkip}
        projectStatus={projectStatus}
        status={status}
        changeProjectStatus={changeProjectStatus}
        project={analyticProject}
      />

      <Outlet context={analyticPageOutlet} />
    </div>
  );
};
export default AnalyticDetailsLayout;
